import { render, staticRenderFns } from "./LPzj.vue?vue&type=template&id=24b8293c&scoped=true"
import script from "./LPzj.vue?vue&type=script&lang=js"
export * from "./LPzj.vue?vue&type=script&lang=js"
import style0 from "./LPzj.vue?vue&type=style&index=0&id=24b8293c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8293c",
  null
  
)

export default component.exports